import api from '@pray/shared/utils/api';

export async function getPayoutById({ artistId, payoutId }) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!payoutId) throw new Error('Payout ID is required');

  const url = `/web/studio/artists/${artistId}/payouts/${payoutId}`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
